module.exports = __webpack_public_path__ + "img/viajar-resorts.6696b7e9.png";